import React from "react";
import Grid from "@mui/material/Grid";
import "./style.css";
import backgroundImage from "./images/bg-roof-panels-gradient.png";
import Rating from "@mui/material/Rating";
import Skeleton from "@mui/material/Skeleton"; // added skeleton import
import Collapse from "@mui/material/Collapse"; // added collapse import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export function getBulletIcons(profileDetails) {
    const bulletIcons = {
        yearEstablished: {
            icon: 'fa-calendar',
            text: 'Established in ' + profileDetails.yearEstablished
        },
        panelWarranty: {
            icon: 'fa-bolt',
            text: profileDetails.panelWarranty + ' Panel Warranty'
        },
        workmanshipWarranty: {
            icon: 'fa-wrench',
            text: profileDetails.workmanshipWarranty + ' Workmanship Warranty'
        },
        totalStaff: {
            icon: 'fa-users',
            text: profileDetails.totalStaff + ' Staff'
        },
        annualInstallations: {
            icon: 'fa-check',
            text: profileDetails.annualInstallations + ' Annual Installations'
        },
        publicLiabilityInsurance: {
            icon: 'fa-calculator',
            text: 'Public Liability Insurance'
        },
        dedicatedSupport: {
            icon: 'fa-phone',
            text: 'Dedicated Support Team'
        },
        seaiApproved: {
            icon: 'fa-thumbs-up',
            text: 'SEAI Approved Installer'
        }
    };
    return bulletIcons;
}

import { useState } from "react";

const ProviderSummary = ({ profileDetails, reviewsUrl, reviewsRating, reviewsTotal, name, url, openingHours, profileVerified }) => {
    const bullets = profileDetails.bullets || {};
    const bulletIcons = getBulletIcons(profileDetails);
    const bulletKeys = Object.keys(bullets).filter(key => bullets[key]);
    const [openHoursOpen, setOpenHoursOpen] = useState(false);
    console.log("Reviews Total:", reviewsTotal);

    // Responsive paddingLeft for desktop/mobile
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    const responsivePaddingLeft = isMobile ? 16 : 224;
    // For the name, use a larger left offset on mobile so it doesn't overlap the logo
    const nameLeft = isMobile ? 124 : 224;
    const nameWidth = isMobile ? `calc(100% - 110px)` : `calc(100% - 224px)`;

    return (
        <div>
            {/* Top Section with background and profile image */}
            <Grid container spacing={2} alignItems="flex-start" style={{ 
                position: "relative", // ensure absolute children are positioned relative to this container
                paddingTop: 60,
                paddingBottom: 60,
                paddingLeft: responsivePaddingLeft,
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right center', // crop from left if needed
                minHeight: 86,
                borderTopLeftRadius: 11,    // radius for top corners only
                borderTopRightRadius: 11,
                borderBottomLeftRadius: 0,  // flat bottom corners
                borderBottomRightRadius: 0
            }}>
                {profileDetails.logo && (
                    <Grid container justifyContent="left" size={2} style={{ marginBottom: -20, position: "absolute", left: 30 }}>
                        {(() => {
                            const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
                            const imgSize = isMobile ? 90 : 150;
                            const imgPadding = isMobile ? 10 : 20;
                            return (
                                <img
                                    src={profileDetails.logo + '?v=' + Date.now()} 
                                    alt="Logo"
                                    style={{
                                        width: imgSize,
                                        height: imgSize,
                                        aspectRatio: "1/1",
                                        objectFit: "contain",
                                        borderRadius: "50%",
                                        backgroundColor: "#fff",
                                        border: "1px solid #ABDC8B",
                                        maxWidth: "none"
                                    }}
                                />
                            );
                        })()}
                    </Grid>
                )}
                {/* New Name Display - updated for vertical centering */}
                <Grid item xs={12} style={{
                    position: "absolute",
                    top: "50%",
                    left: nameLeft,
                    transform: "translateY(-50%)",
                    zIndex: 20,
                    width: nameWidth
                }}>
                    <Grid container direction="column" alignItems="flex-start" style={{ padding: 20, paddingRight:40 }}>
                        <Grid item>
                            <h1 style={{ color: "#023a51", fontSize: isMobile ? "28px" : "35px", fontWeight: "700", margin: 0, font: "Manrope" }}>
                                {name}
                            </h1>
                        </Grid>
                        {profileVerified === 'Verified' && (
                            <Grid item style={{ marginTop: 8 }}>
                                <Grid container alignItems="center" wrap="nowrap" style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                                    <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                        <img 
                                            src="https://energyefficiency.ie/wp-content/uploads/2025/02/verified.png" 
                                            alt="Verified" 
                                            style={{ width: 20, height: 20, marginRight: 8, display: 'block' }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <span style={{ fontSize: '18px', color: '#229626', lineHeight: 1, display: 'flex', alignItems: 'center' }}>
                                            Verified Installer
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

            </Grid>
            {/* Bottom Section with bullet points and (conditionally) reviews/opening hours */}
            <Grid
                container
                direction="column"
                spacing={1}
                style={{
                    marginTop: 20,
                    paddingLeft: isMobile ? 30 : responsivePaddingLeft,
                    paddingRight: isMobile ? 30 : 0,
                }}
            >
                {profileDetails.placeId && <>
                    {/* Reviews and Opening Hours on the same line */}
                    <Grid container spacing={2} alignItems="center" style={{ marginBottom: 8 }}>
                        {/* Google Ratings */}
                        <Grid item size={{sx: 12, sm: 6}} style={{ marginTop: isMobile ? 30 : 0 }}>
                            {(typeof reviewsUrl === 'undefined' || typeof reviewsRating === 'undefined' || typeof reviewsTotal === 'undefined') ? (
                                <Skeleton variant="text" width={300} height={30} />
                            ) : (
                                <a 
                                    href={reviewsUrl} 
                                    target="_blank" 
                                    className="reviews-link"
                                    style={{ 
                                        color: "blue",  
                                        display: "flex", 
                                        alignItems: "center", 
                                        lineHeight: 1 
                                    }}
                                >
                                    <span style={{ lineHeight: 1 }}>{reviewsRating}</span>
                                    <Rating 
                                        name="read-only" 
                                        value={Number(reviewsRating)} 
                                        precision={0.1} 
                                        readOnly 
                                        style={{ marginLeft: 10, lineHeight: 1 }}
                                    />
                                    <span style={{ marginLeft: 10, lineHeight: 1 }}>
                                        ({reviewsTotal} Google Ratings)
                                    </span>
                                </a>
                            )}
                        </Grid>
                        {/* Opening Hours Inline */}
                        <Grid item size={{sx: 12, sm: 6}}>
                            {typeof openingHours === 'undefined' || typeof openingHours.weekday_text === 'undefined' ? (
                                <Skeleton variant="rectangular" width={170} height={30} style={{ borderRadius: 10 }} />
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', userSelect: 'none', marginLeft: 0 }}
                                    onClick={() => setOpenHoursOpen((prev) => !prev)}
                                    aria-expanded={openHoursOpen}
                                    aria-controls="opening-hours-collapse"
                                    tabIndex={0}
                                >
                                    <span style={{ fontSize: '17px', fontWeight: 700, color: '#023a51', marginRight: 10, letterSpacing: 0.2 }}>
                                        Opening Hours
                                    </span>
                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 0 }}>
                                        {typeof openingHours.open_now === 'boolean' && (
                                            <span style={{
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                color: openingHours.open_now ? '#229626' : '#d32f2f',
                                                background: openingHours.open_now ? '#eafbe7' : '#fbeaea',
                                                borderRadius: 6,
                                                padding: '2px 10px',
                                                marginRight: 8,
                                                marginLeft: 0,
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {openingHours.open_now ? 'Open Now' : 'Closed Now'}
                                            </span>
                                        )}
                                        <i className={`fa fa-chevron-${openHoursOpen ? 'up' : 'down'}`} style={{ color: '#229626', fontSize: 16 }}></i>
                                    </div>
                                </div>
                            )}
                        </Grid>
                    </Grid>
                    {/* Collapsible Opening Hours Table (below, not inline) */}
                    {typeof openingHours !== 'undefined' && typeof openingHours.weekday_text !== 'undefined' && (
                        <Collapse in={openHoursOpen} timeout="auto" unmountOnExit id="opening-hours-collapse">
                            <TableContainer style={{ marginTop: 10, maxWidth: 420, minWidth: 280 }}>
                                <Table size="small" aria-label="opening hours">
                                    <TableBody>
                                        {openingHours.weekday_text.map((line, idx) => {
                                            const isToday = new Date().getDay() === (idx === 6 ? 0 : idx + 1);
                                            const [day, hours] = line.split(': ');
                                            const isLast = idx === openingHours.weekday_text.length - 1;
                                            return (
                                                <TableRow key={idx} style={{ background: isToday ? '#eafbe7' : 'transparent' }}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        style={{
                                                            fontWeight: isToday ? 700 : 400,
                                                            color: '#023a51',
                                                            borderBottom: isLast ? 'none' : undefined
                                                        }}
                                                    >
                                                        {day}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            color: '#023a51',
                                                            borderBottom: isLast ? 'none' : undefined
                                                        }}
                                                    >
                                                        {hours}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Collapse>
                    )}
                    {/* Divider between ratings/opening hours and bullets */}
                    <hr style={{
                        border: 0,
                        borderTop: '1.5px solid #d6eac7',
                        margin: '0px 0 10px 0',
                        width: '100%'
                    }} />
                </>}
                {/* Bullet Points */}
                <Grid item>
                    <Grid container spacing={2} style={{ paddingTop: 15, paddingBottom: 30 }}>
                        {(isMobile ? bulletKeys.slice(0, 4) : bulletKeys).map(key => (
                            <Grid key={key} size={isMobile ? 12 : 6} style={{ display: "flex", alignItems: "center" }}>
                                <i className={`fa ${bulletIcons[key].icon}`} 
                                   style={{ 
                                       marginRight: 15, 
                                       display: "flex", 
                                       alignItems: "center", 
                                       justifyContent: "center", 
                                       minWidth: 30, 
                                       color: "#229626"
                                   }}>
                                </i>
                                <span>{bulletIcons[key].text}</span>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default ProviderSummary;